import { render, staticRenderFns } from "./AddVehicle.vue?vue&type=template&id=4284972c&scoped=true&"
import script from "./AddVehicle.vue?vue&type=script&lang=js&"
export * from "./AddVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4284972c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/forge/portmann.hmd.lv/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCard,VFlex,VForm,VIcon,VLayout,VSelect,VTextField})
